import { useState } from 'react';
import { MyMenuContent } from '@/constant/mymenu';
import { useAtom } from 'jotai';
import { MyInfoState } from '@/recoil/atom';
import { MyMenuDrawerProps } from '@/components/MenuDrawer/MyMenuDrawer';
import useMainProps from './useMainProps';

export type MyMenuDrawerSettings = {
  readonly isOpen: boolean;
  readonly onClose: () => void;
};

const useMyMenuDrawerProps = ({
  isOpen,
  onClose,
}: MyMenuDrawerSettings): MyMenuDrawerProps => {
  const [currSub, setCurrSub] =
    useState<MyMenuDrawerProps['currSubMenu']>(null);

  const [myInfo] = useAtom(MyInfoState);

  const menuOnClose = () => {
    if (currSub) {
      closeSubMenu();
    } else {
      onClose();
    }
  };

  const openSubMenu = (id: MyMenuContent) => {
    if (!id || id === currSub) return;
    setCurrSub(id);
  };

  const closeSubMenu = (id?: MyMenuContent) => {
    if (id && id !== currSub) return;
    setCurrSub(null);
  };

  const subMenuOnClose = () => {
    setCurrSub(null);
  };

  return {
    currSub,
    isOpen,
    menuOnClose,
    currSubMenu: currSub,
    subMenuOnClose,
    openSubMenu,
    closeSubMenu,
    myInfo,
    mainProps: useMainProps({ isOpen, myInfo, onClose, openSubMenu }),
  };
};

export default useMyMenuDrawerProps;
